const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;
const uploadIcon = `${EASYCOMMERCE.assets}admin/img/icons/upload-icon.png`;

const Business = ({ formValues, setFormValues }) => {

    const { business_type: businessTypes, countries } = EASYCOMMERCE;

    const openMediaLibrary = () => {
        const frame = wp.media({
            title: "Select Image",
            button: { text: "Use selected Image" },
            multiple: false,
        });

        frame.on("open", () => {
            const selection = frame.state().get("selection");
            const attachment = wp.media.attachment(formValues.logo?.id);
            attachment.fetch();
            selection.add(attachment);
        });

        frame.on("select", () => {
            const [selected] = frame.state().get("selection").toJSON();
            if (selected?.url) {
                setFormValues(prev => ({
                    ...prev,
                    logo: selected.url
                }));
            }
        });
        
        frame.open();
    };

    const handleChange = (field) => (e) =>
        setFormValues({ ...formValues, [field]: e.target.value });

    const renderSelect = (id, name, label, value, options) => (
        <div className="flex flex-col space-y-2">
            <label htmlFor={id} className="text-ec-body text-[16px] font-medium">
                {label}
            </label>
            <select
                id={id}
                name={name}
                className="easycommerce-wizard-input w-full"
                value={value}
                onChange={handleChange(id)}
            >
                {Object.entries(options).map(([val, text]) => (
                    <option key={val} value={val}>
                        {text}
                    </option>
                ))}
            </select>
        </div>
    );

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px 600px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="w-[40%] bg-white flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl">
                <div className="flex flex-col w-full space-y-6">

                    {/* Business Name */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="store_name" className="text-ec-body text-[16px] font-medium">
                            Business Name
                        </label>
                        <input
                            id="store_name"
                            type="text"
                            name="general-business-store_name"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Write your business name"
                            value={formValues.store_name}
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, store_name: e.target.value }))
                            }
                        />
                    </div>

                    {/* Logo Upload */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">Logo</label>
                        <div className="flex flex-col items-center border border-ec-border border-dashed rounded p-6">
                            {formValues.logo ? (
                                <img
                                    src={formValues.logo}
                                    alt="logo"
                                    onClick={openMediaLibrary}
                                    className="max-h-40 object-fill cursor-pointer hover:opacity-70"
                                />
                            ) : (
                                <>
                                    <img src={uploadIcon} alt="upload icon" />
                                    <p className="text-ec-placeholder text-[16px] leading-[26px] mt-1 mb-4">
                                        Click to upload your store logo
                                    </p>
                                    <button
                                        type="button"
                                        onClick={openMediaLibrary}
                                        className="flex justify-center items-center gap-2 font-inter bg-white group border border-ec-primary py-[11px] px-4 rounded-lg text-ec-primary hover:text-white hover:bg-ec-primary focus:shadow-none focus:text-white focus:bg-ec-secondary lg:text-sm transition-all ease-in-out duration-500"
                                    >
                                        Upload Logo
                                    </button>
                                </>
                            )}
                            <input type="hidden" name="general-business-logo" value={formValues.logo} />
                        </div>
                    </div>

                    {/* Business Type */}
                    {renderSelect(
                        "business_type",
                        "general-business-business_type",
                        "Business Type",
                        formValues.business_type,
                        businessTypes
                    )}

                    {/* Business Address */}
                    {renderSelect(
                        "country",
                        "general-business-country",
                        "Business Address",
                        formValues.country,
                        countries
                    )}

                    {/* Email */}
                    <div className="flex flex-col space-y-2">
                        <label htmlFor="email" className="text-ec-body text-[16px] font-medium">
                            Business Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            name="general-business-business_email"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Write your business email"
                            value={formValues.email}
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, email: e.target.value }))
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Business;
